// html.pipe.ts
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'html',
})
export class HtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | number | null | undefined): SafeHtml {
    if (value === null || value === undefined) return '';

    return this.sanitizer.bypassSecurityTrustHtml(String(value));
  }
}
